import { render, staticRenderFns } from "./ActivityContext.vue?vue&type=template&id=481e59ce&lang=pug"
import script from "./ActivityContext.vue?vue&type=script&lang=js"
export * from "./ActivityContext.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports